var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    attrs: {
      "background": "static/img/Heavy-Duty-Warehouse-Trucks-in-Miami.jpg"
    }
  }, [_c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "app2 flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('img', {
    staticClass: "dark-logo",
    attrs: {
      "src": "static/img/logo.png",
      "alt": "homepage"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checklogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='icon-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "placeholder": "Username",
      "name": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading == true
    }
  }, [_vm._v("Login")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('vue-element-loading', {
    staticStyle: {
      "background-color": "transparent"
    },
    attrs: {
      "spinner": "spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4 text-right"
  }, [_c('button', {
    staticClass: "btn btn-link px-4",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.resetpassword
    }
  }, [_vm._v("Forgot Password")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])])])]), _vm._v(" "), _vm._m(0)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card text-white py-5 d-md-down-none",
    staticStyle: {
      "width": "44%",
      "background-color": "#f58220 !important"
    }
  }, [_c('h4', {
    staticClass: "login_title"
  }, [_vm._v("Delivering Happiness")]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [_c('div', [_c('p', {
    staticClass: "xb_text"
  }, [_vm._v("Instantly grow your e-commerce business through our extensive network and create happy customers through value added services and on time delivery")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bca2c4a","hasScoped":true}!./src/views/components/login/login.component.html
// module id = 983
// module chunks = 1